import { CareerCommit } from '../types';

// Newest first, exactly as `git log` prints it. The graph is generated from this order:
// - `work` commits each get their own branch (named by scope) that forks off main just below them;
//   a `done` one merges back just above, a `current` one stays open as HEAD.
// - `lead` commits share a single open branch, forked off main just below the oldest of them.
export const careerLog: CareerCommit[] = [
  {
    hash: '·······',
    type: 'feat',
    scope: 'caterpillar',
    message: 'SDE intern',
    role: 'SDE Intern',
    org: 'Caterpillar',
    lane: 'main',
    start: '2027-01',
    end: null,
    status: 'upcoming',
    details: [],
  },
  {
    hash: 'b91f02d',
    type: 'feat',
    scope: 'samsung',
    message: 'AI test-management platform, 85k+ test cases',
    role: 'Project Intern',
    org: 'Samsung R&D Institute India (PRISM)',
    lane: 'work',
    start: '2026-07',
    end: 'now',
    status: 'current',
    details: [
      'replaced Excel-based QA workflows across SmartThings, Bixby, Knox, Samsung Health',
      'hybrid RAG: pgvector semantic search + FTS fallback + guarded NL→SQL (sqlglot AST validation, tenant-scoped read-only execution)',
      'multi-provider LLM layer with automatic failover (Gauss → Qwen3 → Mistral → Ollama → Gemini → deterministic local)',
      'RCA engine: matches failure logs to similar historical failures and suggests fixes',
      'release impact scoring: predicts affected tests from code churn, defect density, failure rates',
      'React 19 · Node/Express · FastAPI · PostgreSQL · multi-tenant JWT/RBAC · Docker · Jenkins',
    ],
  },
  {
    hash: 'c7a2e19',
    type: 'lead',
    scope: 'csi',
    message: 'web team lead, hackathon site + core team',
    role: 'Web Team Lead',
    org: 'CSI-VIT',
    lane: 'lead',
    start: '2026-01',
    end: 'now',
    status: 'current',
    details: [
      'led the web team; guided juniors building the hackathon website from planning to deployment',
      'core team for the hackathon: planning and execution',
      'earlier, senior core (2025-04 → 2026-01): ran 2 events, mentored juniors',
    ],
  },
  {
    hash: 'a3d57e0',
    type: 'lead',
    scope: 'riviera',
    message: 'tech manager, led the tech team for both fests',
    role: 'Tech Manager',
    org: 'Riviera & Gravitas',
    lane: 'lead',
    start: '2026',
    end: null,
    status: 'done',
    details: [
      'headed the tech team for VIT’s two flagship fests: Riviera (cultural) and Gravitas (tech)',
      'planned and delegated work across the team to keep delivery on track for fest deadlines',
      'tech point of contact for the organising and event teams',
      'mentored juniors and grew them into owning parts of the fest stack',
    ],
  },
  {
    hash: '8e6c4b1',
    type: 'feat',
    scope: 'smartlinks',
    message: 'TMS backend, load + route optimization',
    role: 'SDE',
    org: 'Smartlinks',
    lane: 'work',
    start: '2025-12',
    end: '2026-07',
    status: 'done',
    details: [
      'transportation management system: load optimization, dynamic route planning, cost reduction',
      'moved the system to a cloud worker architecture for async, large-scale job processing',
      'Angular ops dashboard giving real-time visibility into logistics workflows',
      'onboarded and mentored interns on the codebase and system design',
    ],
  },
  {
    hash: '5fa8d13',
    message: 'JPMorgan Code for Good: finalist',
    role: 'Finalist',
    org: 'JPMorgan Code for Good',
    lane: 'main',
    start: '2025',
    end: null,
    status: 'done',
    tag: 'jpmc-cfg-finalist',
    details: [],
  },
  {
    hash: '72b0f9a',
    type: 'lead',
    scope: 'firefox-club',
    message: 'tech head, backends for 10+ club sites',
    role: 'Technical Head',
    org: 'Mozilla Firefox Club VIT',
    lane: 'lead',
    start: '2024-06',
    end: '2026-01',
    status: 'done',
    details: [
      'built and deployed backends for 10+ club and event websites (technical core, 2024-06 → 2025-03)',
      'tech head (2025-03 → 2026-01): led the tech team, backend/infra for club events',
      'mentored juniors into owning projects',
    ],
  },
  {
    hash: '0c1d9e4',
    type: 'init',
    message: 'B.Tech CSE (AI & ML), VIT Vellore',
    role: 'B.Tech CSE (AI & ML)',
    org: 'VIT Vellore',
    lane: 'main',
    start: '2023-08',
    end: null,
    status: 'done',
    tag: 'v0',
    details: ['CGPA 9.34', 'Academic Merit Award ×3 (2023-24, 2024-25, 2025-26)', 'graduating 2027-08'],
  },
];
